// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Wo-z","imageAndVideoCount":"Xo-z","imageAndVideoContainer":"Yo-z","viewAllReviews":"Zo-z"};